import { PageCanvas } from "@/components/page-canvas";
import { Head, Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import SettingsLayout from "@/layouts/settings_layout";
import { Card, CardContent } from "@/components/ui/card";
import { userCustomerDeletionPath } from "@/routes";
import type { Deletion } from "./show";

export default function Deletions({ deletions }: { deletions: Deletion[] }) {
  const { t } = useTranslation();
  return (
    <SettingsLayout>
      <Head title={t("customer_deletions.queue")} />
      <PageCanvas padded={false}>
        <h1 className="text-page font-display">
          {t("customer_deletions.queue")}
        </h1>
        <Card>
          <CardContent className="divide-y">
            {deletions.length === 0 && (
              <p className="py-6">{t("customer_deletions.empty")}</p>
            )}
            {deletions.map((deletion) => (
              <div key={deletion.id} className="space-y-2 py-4">
                <Link
                  className="break-all underline"
                  href={userCustomerDeletionPath(deletion.id)}
                >
                  {t("customer_deletions.states." + deletion.state)} ·{" "}
                  {deletion.customer_name || deletion.id}
                </Link>
              </div>
            ))}
          </CardContent>
        </Card>
      </PageCanvas>
    </SettingsLayout>
  );
}
